import { fetchWrapper } from "@/helpers"
import { defineStore } from "pinia"
import { nextTick } from "vue"

const baseUrl = process.env.VUE_APP_PROXY_SERVER + "/api/Project"

export const useProjectStore = defineStore(`${process.env.VUE_APP_NAME}_projectStore`, {
  id: "projects",
  state: () => ({
    user: {},
    userProjects: [],
    lastUpdateProject: '',
  }),
  persist: true,
  actions: {
    async fetchProjects(refresh = false) {
      var currentUser = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_NAME}_user`));

      if(refresh || this.userProjects.length == 0 || Object.keys(this.user).length == 0 || this.user.id != currentUser.id || !this.user.currentProject) {
        await this.getUserProjects();
        await this.setUserProject();
      }
    },
    async getUserProjects() {
      try {
        this.user = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_NAME}_user`))
        var allProj = await fetchWrapper.get(`${baseUrl}/AllProject`)

        allProj.projects = allProj.projects.filter(x =>
          this.user.projectIds.includes(x.id),
        )
        
        this.userProjects = allProj.projects
        this.lastUpdateProject = allProj.lastUpdate
      } catch (error) {
        this.userProjects = { error }
      }
    },
    async setUserProject() {
      if (!this.user.currentProject) {
        this.user = { ...this.user, currentProject: this.userProjects[0] || null };
      } else {
        var project = this.userProjects.find(x => x.id == this.user.currentProject?.id);
        this.user = { ...this.user, currentProject: project || this.userProjects[0] || null };
      }

      localStorage.setItem(`${process.env.VUE_APP_NAME}_user`, JSON.stringify(this.user))
    },
    async userCurrentProject() {
      await nextTick()

      return this.user.currentProject || null;
    },
    async checkUpdateProject(){
      var lastUpdate = await fetchWrapper.get(`${baseUrl}/LastUpdate`)

      return (lastUpdate == this.lastUpdateProject)
    },
    refreshUser() {
      this.user = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_NAME}_user`))
    },
  },
})
